// eslint-disable class-methods-use-this
import { customElement } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin';
import { TefComsCustomerAttributeBase } from '@common/customerAttributes/TefComsCustomerAttributeBase';
import { CustomerAttribute } from '@common/customerAttributes/types';
import { TemplatingMixin } from '@common/lit/mixins/TemplatingMixin';
import { Theme } from '@common/types/enum';
import { store } from '@src/store';
import { setCustomerAttribute } from '@src/store/consents';
import { ReplaceElementsMixin } from './mixins/ReplaceElementsMixin';
import { templates } from './templates';

const CompositeClass = ReplaceElementsMixin(
  TemplatingMixin(connect(store)(TefComsCustomerAttributeBase), Theme.OCCL, templates),
);

@customElement('tef-coms-customer-attribute')
export class TefComsCustomerAttribute extends CompositeClass {
  connectedCallback() {
    super.connectedCallback();
    // Only available here after store init and not on top of the class :(
    this.setTemplatingTheme(this.theme);
  }

  get customerAttributes() {
    const { consents: { customerAttributes } } = store.getState();
    return customerAttributes!;
  }

  get theme() {
    const { config: { occluri } } = store.getState();
    return occluri ? Theme.OCCL : Theme.TEFONE;
  }

  get userIsInRegisterFlow() {
    const { config: { registerToken, newcustomer } } = store.getState();
    //             LEGACY           RAITT
    return Boolean(registerToken || newcustomer);
  }

  get userIsInEditMode() {
    const { config: { mode }, consents } = store.getState();
    if (mode!.includes('multiedit') && consents.editmodeActiveGroupInd === -1) {
      return false;
    }
    return true;
  }

  saveCustomerAttributeToStore(customerAttribute: CustomerAttribute): void {
    store.dispatch(setCustomerAttribute(customerAttribute));
  }

  getTemplateFnFor(templateName: string) {
    return this.getTemplateFn(templateName);
  }

  get mainComponentTag() {
    return 'tef-coms';
  }
}
